import { Directive, ElementRef, Output, EventEmitter, HostListener, Input, NgZone } from '@angular/core';
import * as ps from 'perfect-scrollbar';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/debounceTime';
var ScrollDirective = /** @class */ (function () {
    function ScrollDirective(el, zone) {
        this.el = el;
        this.zone = zone;
        this.debounceTime = 100;
        this.scrolled = new EventEmitter();
        this.scrolledUp = new EventEmitter();
        this.subscriptions = [];
    }
    ScrollDirective.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.el.nativeElement && ps) {
            this.zone.runOutsideAngular(function () {
                ps.initialize(_this.el.nativeElement, {
                    handlers: ['click-rail', 'drag-scrollbar', 'wheel']
                });
                _this.enableEvents();
            });
        }
    };
    ScrollDirective.prototype.ngOnChanges = function (changes) {
        this.update();
    };
    ScrollDirective.prototype.ngAfterContentChecked = function () {
        this.check();
    };
    ScrollDirective.prototype.ngOnDestroy = function () {
        var _this = this;
        this.disableEvents();
        if (this.el.nativeElement && ps) {
            this.zone.runOutsideAngular(function () {
                ps.destroy(_this.el.nativeElement);
            });
        }
    };
    ScrollDirective.prototype.update = function () {
        var _this = this;
        if (this.el.nativeElement && ps) {
            this.zone.runOutsideAngular(function () {
                _this.disableEvents();
                ps.update(_this.el.nativeElement);
                _this.enableEvents();
            });
        }
    };
    ScrollDirective.prototype.isChanged = function () {
        var doChange = false;
        if (this.el.nativeElement && ps) {
            var nEl = this.el.nativeElement, childCount = nEl.getElementsByTagName('*').length;
            doChange = (this.childCount !== childCount);
            if (!doChange) {
                var width = nEl.offsetWidth, height = nEl.offsetHeight;
                doChange = (width !== this.width || height !== this.height);
                if (!doChange) {
                    var child = nEl.children[0];
                    var contentWidth = void 0, contentHeight = void 0;
                    if (childCount > 0) {
                        contentWidth = child.offsetWidth;
                        contentHeight = child.offsetHeight;
                    }
                    else {
                        contentWidth = this.contentWidth;
                        contentHeight = this.contentHeight;
                    }
                    doChange = (contentWidth !== this.contentWidth || contentHeight !== this.contentHeight);
                }
            }
        }
        return doChange;
    };
    ScrollDirective.prototype.check = function () {
        var _this = this;
        this.zone.runOutsideAngular(function () {
            if (_this.isChanged()) {
                _this.width = _this.el.nativeElement.offsetWidth;
                _this.height = _this.el.nativeElement.offsetHeight;
                _this.childCount = _this.el.nativeElement.getElementsByTagName('*').length;
                if (_this.childCount > 0) {
                    _this.contentWidth = _this.el.nativeElement.children[0].offsetWidth;
                    _this.contentHeight = _this.el.nativeElement.children[0].offsetHeight;
                }
                _this.update();
            }
        });
    };
    ScrollDirective.prototype.enableEvents = function () {
        var _this = this;
        var observableReachEnd = Observable.fromEvent(this.el.nativeElement, 'ps-y-reach-end');
        var observableReachStart = Observable.fromEvent(this.el.nativeElement, 'ps-y-reach-start');
        this.subscriptions.push(observableReachEnd.debounceTime(this.debounceTime).distinct().subscribe(function (event) {
            _this.scrolled.emit(event);
        }));
        this.subscriptions.push(observableReachStart.debounceTime(this.debounceTime).distinct().subscribe(function (event) {
            _this.scrolledUp.emit(event);
        }));
    };
    ScrollDirective.prototype.disableEvents = function () {
        this.subscriptions.forEach(function (sub) {
            sub.unsubscribe();
        });
    };
    ScrollDirective.prototype.onWindowResize = function () {
        this.update();
    };
    ScrollDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[gp-scroll]'
                },] },
    ];
    /** @nocollapse */
    ScrollDirective.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: NgZone, },
    ]; };
    ScrollDirective.propDecorators = {
        'debounceTime': [{ type: Input },],
        'scrolled': [{ type: Output },],
        'scrolledUp': [{ type: Output },],
        'onWindowResize': [{ type: HostListener, args: ['window:resize',] },],
    };
    return ScrollDirective;
}());
export { ScrollDirective };
//# sourceMappingURL=scroll.directive.js.map